import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreLink,
  moreText = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-1.5 h-6 rounded-full bg-accent-500" />
        <div className="min-w-0">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 whitespace-nowrap">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-1 truncate">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap shrink-0"
        >
          {moreText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}